import React from 'react';

import { useSelector } from 'react-redux';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';

import { TeacherReservePageInactive } from './-inactive/inactive';
import { TeacherReservePageActive } from './-active/active';

import './teacher-reserve-page.css';

export function TeacherReservePage() {
    const teacherReserveInactive = useSelector(getFeatureFlags)?.teacherReserveInactive;

    return teacherReserveInactive ? <TeacherReservePageInactive /> : <TeacherReservePageActive />;
}
